import { useCallback } from 'react'
import CPTCEModalEditor from '../CPTCEModalEditor'
import useDataFromCPTME from '../CPTCEModalEditor/useDataFromCPTME'
import { ComponentWithPermissions } from '../../../../../../../../../../../baseComponents/CreateRoutering/types'
import { ModalCreateEditStructureLayout } from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { PdfConfigTemplateTabProps } from '../../../../types'
import { PdfConfigSingleModuleVariables } from '../../../../../types'
import { ModulePdfConfigParent } from '../types'
import TwinForm from '../../../../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../../../../../../../forms/TwinForm/types'
import { addAntiUnsaveElement } from '../../../../../../../../../../../utils/reducers/reduxDispatch'

type CPTModalEditProps = CPTModalEditLogicProps & ComponentWithPermissions & {
    moduleVars: PdfConfigSingleModuleVariables
    setMyModule: React.Dispatch<React.SetStateAction<ModulePdfConfigParent>>
}

const CPTModalEdit: React.FC<CPTModalEditProps> = ({ openModal, userPermissions, moduleVars, setMyModule, ...rest }) => {
    const { prevSubmitEditModule } = useCPTModalEdit({ openModal, ...rest })
    const { t } = useTwinTranslation()

    return (
        <TwinForm beforeSubmitHandler={prevSubmitEditModule} className='flex flex-auto flex-col'>
            <ModalCreateEditStructureLayout translations={{ button: t('save', 'Guardar'), title: t('editModule', 'Editar módulo') }} loading={false} haveButtonPermissions={permissionCheck(userPermissions, 'update')} className='modal_negative_margin flex flex-col'>
                <div className='overflow-auto flex flex-auto flex-col'>
                    <CPTCEModalEditor pdfConfigElement={{ ...openModal?.allRowData as any }} userPermissions={userPermissions} moduleVars={moduleVars} setMyModule={setMyModule} documentType={rest.config.type}/>
                </div>
            </ModalCreateEditStructureLayout>
        </TwinForm>
    )
}

interface CPTModalEditLogicProps extends PdfConfigTemplateTabProps {
    modifyKey: number
    subKey?: string
}

const useCPTModalEdit = ({ setOpenModal, modifyKey, setConfig, openModal }: CPTModalEditLogicProps) => {
    const { beforeSubmitPrev } = useDataFromCPTME()
    const prevSubmitEditModule: BeforeSubmitHandler = useCallback((vals) => {
        addAntiUnsaveElement(['pdf_template_changes', '{}'])
        const allRowData = openModal?.allRowData
        const { cssConfig, extraProps } = beforeSubmitPrev(vals)
        if (allRowData) {
            const splitKey = String(modifyKey).split(',')
            const myPageKey = splitKey[0]
            const mySectionKey = splitKey[1]
            setConfig((old) => {
                const copy = JSON.parse(JSON.stringify(old))
                copy.pages[myPageKey].sections[mySectionKey].elements[allRowData.subKey] = {
                    ...copy.pages[myPageKey].sections[mySectionKey].elements[allRowData.subKey],
                    cssConfig,
                    extraProps,
                }                
                return { ...copy }
            })
            setOpenModal(null)
        }
        return false
    }, [modifyKey, setConfig, setOpenModal, openModal, beforeSubmitPrev])
    return { prevSubmitEditModule }
}

export default CPTModalEdit